import { gql } from '@apollo/client';

import { CreateFillInTheBlanksExerciseInput, FillInTheBlanksExercise } from '../../types';
import { fillInTheBlanksExerciseFragment } from '../fragments';

export interface CreateFillInTheBlanksExerciseMutationVariables {
  courseId: string;
  subjectId: string;
  input: CreateFillInTheBlanksExerciseInput;
}

export interface CreateFillInTheBlanksExerciseMutationResult {
  fillInTheBlanksExercise: FillInTheBlanksExercise;
}

export const createFillInTheBlanksExerciseMutation = gql`
  mutation CreateFillInTheBlanksExerciseMutation($courseId: String!, $subjectId: String!, $input: CreateFillInTheBlanksExerciseMutationInput!) {
    fillInTheBlanksExercise(courseId: $courseId, subjectId: $subjectId, input: $input)
      @rest(type: "Exercise", path: "courses/{args.courseId}/subjects/{args.subjectId}/exercises", method: "POST") {
      ...FillInTheBlanksExercise
    }
  }
  ${fillInTheBlanksExerciseFragment}
`;
